import { render } from "./AdminShipmentTable.vue?vue&type=template&id=22539ec9&scoped=true"
import script from "./AdminShipmentTable.vue?vue&type=script&lang=js"
export * from "./AdminShipmentTable.vue?vue&type=script&lang=js"

import "./AdminShipmentTable.vue?vue&type=style&index=0&id=22539ec9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22539ec9"]])

export default __exports__